module.exports = __webpack_public_path__ + "6e256fe4cdc9260ddafb3f857b13db55.svg";